import { Header, ModifierGroup } from "../types";
import { useCreateItemMutation, useTypedSelector } from "../store";
import { showToast, ToastType } from "../utils/toast.utils";
import ItemForm from "../forms/item.form";
import { itemSchema } from "../configs";
import { useNavigate } from "react-router-dom";

const CreateItemWrapper = () => {
  const restaurant = useTypedSelector((state) => state.session.restaurant);

  if (!restaurant)
    return (
      <div className="w-full flex justify-center mt-4 text-xl font-semibold">
        Veuillez sélectionner un restaurant
      </div>
    );

  return (
    <div className="w-full flex flex-col items-center justify-center">
      <CreateItem restaurantId={restaurant._id} />
    </div>
  );
};

interface CreateItemProps {
  restaurantId: string;
}

const CreateItem: React.FC<CreateItemProps> = ({ restaurantId }) => {
  const [createItem, { isLoading }] = useCreateItemMutation();
  const navigate = useNavigate();

  const initialValues = {
    displayName: "",
    description: "",
    restaurant: restaurantId,
    headers: [] as Header[],
    price: undefined,
    vatRatePercentage: undefined,
    modifierGroups: [] as ModifierGroup[],
    displayOrder: 1,
  };

  return (
    <div className="p-4 w-full">
      <ItemForm
        initialValues={initialValues}
        validationSchema={itemSchema}
        isLoading={isLoading}
        restaurantId={restaurantId}
        onSubmit={async (values, { resetForm }) => {
          // format headers and modifierGroups to just IDs
          const formattedValues = {
            ...values,
            headers: values.headers.map((h: Header) => h._id),
            modifierGroups: values.modifierGroups.map(
              (mg: ModifierGroup) => mg._id
            ),
            price: Math.trunc(values.price * 100),
          };

          const result = await createItem(formattedValues);
          if (!result.error) {
            showToast("Produit créé", ToastType.SUCCESS);
            resetForm();
            navigate("/items");
          }
        }}
      />
    </div>
  );
};

export default CreateItemWrapper;
